import { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../apiEndpoints";
import { apiRequest } from "@/network/apiClient";

export const useOpportunityInventory = (
  page,
  pageSize,
  filters,
  searchName,
  fromAll,
  sortBy,
  sortOrder
) => {
  const [data, setData] = useState([]);
  const [totalOpportunity, setTotalOpportunity] = useState(0);
  const [absoluteTotal, setAbsoluteTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      try {
        const params = new URLSearchParams();

        // Pagination
        params.set("page", String(page));
        params.set("page_size", String(pageSize));

        // from_all flag
        params.set("from_all", fromAll ? "true" : "false");

        // 🔹 Lead status (referral / reKYC / insurance) -> lead_status
        const leadStatuses = [];
        if (filters?.leadStatus?.length) {
          leadStatuses.push(...filters.leadStatus);
        }
        if (leadStatuses.length) {
          leadStatuses.forEach((val) => {
            params.append("lead_status", String(val));
          });
        }

        // 🔹 Owner filter (farmer) – ONLY when fromAll
        if (fromAll && filters?.farmer?.length) {
          filters.farmer.forEach((id) => {
            params.append("farmer_id", String(id));
            // results in ?farmer_id=19&farmer_id=21
          });
        }

        // 🔹 Name search
        if (searchName) {
          params.set("name", searchName);
        }

        // 🔹 Product / funnel filter
        if (filters?.products?.length) {
          filters.products.forEach((funnel) => {
            params.append("funnel", String(funnel));
          });
        }

        // 🔹 Status filters → status_name
        const statusNames = [];
        if (filters?.all_status?.length) {
          statusNames.push(...filters.all_status);
        }
        if (filters?.remittance_status?.length) {
          statusNames.push(...filters.remittance_status);
        }
        if (filters?.referral_status?.length) {
          statusNames.push(...filters.referral_status);
        }
        if (filters?.insurance_status?.length) {
          statusNames.push(...filters.insurance_status);
        }
        if (statusNames.length) {
          statusNames.forEach((status) => {
            params.append("status_name", String(status));
          });
        }

        // 🔹 Sorting
        if (sortBy) {
          params.set("sort_by", sortBy);
        }
        if (sortOrder) {
          params.set("sort_order", sortOrder);
        }

        const url = `${import.meta.env.VITE_BASE_URL}/${
          API_ENDPOINTS.GET_OPPORTUNITIES.INVENTORY
        }?${params.toString()}`;

        const result = await apiRequest(url);

        if (result) {
          setData(result.data);
          setTotalOpportunity(result.total);
          setAbsoluteTotal(result.absolute_total);
          setTotalPages(result.total_pages);
        } else {
          console.error("Failed to fetch opportunity inventory:", result?.error);
        }
      } catch (error) {
        console.error("Error fetching opportunity inventory: ", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [page, pageSize, filters, searchName, fromAll, sortBy, sortOrder]);

  return { data, totalOpportunity, isLoading, absoluteTotal, totalPages };
};
